import React from 'react';
import { Link } from 'react-router';

const Logo = ({ className, medal }) => {
    return (
        <Link to="/" style={{ height: 50 }} className={`align-self-center pt-2 pb-2 ${className}`}>
            <img alt="" src={(medal && medal.id) ? medal.Medal : "/images/logos/logo_white.png"} className="h-100 pl-2 align-self-center" />
        </Link>
    );
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/layouts/logo.js